import shouldUseSilentUri from '../utils/useSilentUri';
import { unsubscribeFromBrandSubscription } from '../actions/publicActions';
import { onAfterUnsubscribe } from '../actions/publicActions';
import { orchestrator } from 'satcheljs';
import unsubscribeFromBrandSubscriptionService from '../services/unsubscribeFromBrandSubscriptionService';
import UnsubscribeResponseType from '../schema/unsubscribeResponseType';
import { unsubscribeFromCache } from '../selectors/subscriptionsCacheOperations';
import { ServiceFetchError } from 'owa-service/lib/ServiceFetchError';
import { isSuccessStatusCode } from 'owa-http-status-codes';

orchestrator(unsubscribeFromBrandSubscription, async actionMessage => {
    const {
        unsubscribeSourceType,
        smtpIdentifier,
        unsubscribeSilentUris,
        unsubscribeHttpUri,
        completedCallback,
    } = actionMessage;
    let debugMessage: string;
    let status: UnsubscribeResponseType;

    if (
        (!unsubscribeHttpUri || unsubscribeHttpUri.length === 0) &&
        (!unsubscribeSilentUris || unsubscribeSilentUris.length === 0)
    ) {
        debugMessage = 'No unsubscribe URIs or SilentURIs provided';
        status = UnsubscribeResponseType.Fail;
        onAfterUnsubscribe(
            smtpIdentifier,
            unsubscribeSourceType,
            status,
            debugMessage,
            completedCallback
        );
        return Promise.reject('No unsubscribe URIs or SilentURIs provided');
    }

    if (
        (!unsubscribeSilentUris || !shouldUseSilentUri(unsubscribeSilentUris.length)) &&
        unsubscribeHttpUri
    ) {
        window.open(unsubscribeHttpUri, '_blank');
        debugMessage = 'Opened unsubscribe URI in new tab';
    } else {
        debugMessage = 'No unsubscribe URIs provided';
    }

    const response: Response = await unsubscribeFromBrandSubscriptionService(
        smtpIdentifier,
        unsubscribeSilentUris
    );

    let error = null;
    if (isSuccessStatusCode(response.status)) {
        debugMessage = 'Unsubscribe service called successfully. ' + debugMessage;
        status = UnsubscribeResponseType.Success;
        unsubscribeFromCache(smtpIdentifier);
    } else {
        debugMessage = 'Unsubscribe service failed. ' + debugMessage;
        status = UnsubscribeResponseType.Fail;
        const responseObj = await response.text().then(text => (text ? JSON.parse(text) : {}));
        error = new Error(
            `ResponseCode=${response.status}, ErrorMessage=${responseObj &&
                responseObj.error &&
                responseObj.error.message}`
        ) as ServiceFetchError;

        error.fetchErrorType = 'ServerFailure';
    }

    onAfterUnsubscribe(
        smtpIdentifier,
        unsubscribeSourceType,
        status,
        debugMessage,
        completedCallback
    );

    if (error) {
        return Promise.reject(error);
    }

    return Promise.resolve();
});
